import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.183 6.117a6 6 0 1 0 4.511 3.986","key":"svg-0"}],["path",{"d":"M14.813 17.883a6 6 0 1 0 -4.496 -3.954","key":"svg-1"}]]

const IconCirclesRelation = createReactComponent('outline', 'circles-relation', 'CirclesRelation', __iconNode);

export default IconCirclesRelation;